import React from "react"
import Matter, { Body, Events } from 'matter-js'
import { animateOnline } from './Animation.js'
import './Animation.js'
import './Parallax'
import { bacgrkoundparallax } from './Parallax.js'
import { CloseConnection, SendAction, sendDataChannel } from "../WebRTC/Rtc.js"





let versusGamemode = (localStorage.getItem('VersusGameMode') === 'true');
const CANVAS_WIDTH = 1920;
const CANVAS_HEIGHT = 1080;
var render ;

var Engine = Matter.Engine,
    Render = Matter.Render,
    Runner = Matter.Runner,
    Bodies = Matter.Bodies,
    Composite = Matter.Composite;

var engine = Engine.create();
let gameOver = false;
let P1RestartReady = false
let P2RestartReady = false
let P1fallen = false;
let P2fallen = false;
let P1Connected = false
let P2Connected = false
let P1airState = ""
let P2airState = ""
let isP2Grounded = true
let isP1Grounded = true
let gameSpeed = 3
let ground1;
let ground2;
let ground3;
let player1
let player2;
let isHoldingJumpP2 = false
let holdCounterP2 = 0;
let rightKeyPressP2 = false;
let leftKeyPressP2 = false;
let noGravityP2;
let speedVel = 1;
let maxVel = 5000;
let acc = 0;
let maxAcc = 1;
let distance = 0;
let currentDistance = 0;
let hostxPos = CANVAS_WIDTH * 0.1
let guestxPos = CANVAS_WIDTH * 0.15
let P1category = 0x0002;
let P2category = 0x0004;
let prevRndWidthGround1 = 1;
let prevRndWidthGround2 = 1;
let prevRndWidthGround3 = 1;

class MultiplayerGame extends React.Component{
  constructor(props){
    super(props)
    this.state = {}
  }
  
  componentDidMount(){
    P1Connected = false
    P2Connected = false
    // GameStart();
    render = Render.create({
      element: this.refs.online,
      engine: engine,
      options:{
        height: CANVAS_HEIGHT,
        width: CANVAS_WIDTH,
        wireframes: false,
        showPositions: false
      }
    });
  }
  componentWillUnmount(){
    CloseConnection();
  }
  render(){
    return <div ref='online'/>
  }
}  

export function RestartGame(){
  gameOver = false
  P1fallen = false
  P2fallen = false
  
  document.querySelector('.gameOver').remove()

  Composite.remove(engine.world, [ground1, ground2, ground3])
  ground1 = Bodies.rectangle(CANVAS_WIDTH * 0.3, CANVAS_HEIGHT * 0.8, CANVAS_WIDTH * 0.5 , CANVAS_HEIGHT / 32, { isStatic: true, label: 'Ground', render: {fillStyle: 'red'}, collisionFilter: {category: P1category | P2category}});
  ground2 = Bodies.rectangle(CANVAS_WIDTH, CANVAS_HEIGHT * 0.8, CANVAS_WIDTH / 2 , CANVAS_HEIGHT / 32, { isStatic: true, label: 'Ground', render: {fillStyle: 'green'}, collisionFilter: {category: P1category | P2category} });
  ground3 = Bodies.rectangle(CANVAS_WIDTH * 2, CANVAS_HEIGHT * 0.8, CANVAS_WIDTH * 0.5 , CANVAS_HEIGHT / 32,  { isStatic: true, label: 'Ground' , render: {fillStyle: 'blue'}, collisionFilter: {category: P1category | P2category}});
  Composite.add(engine.world, [ground1, ground2, ground3])

  speedVel = 1;
  maxVel = 5000;
  acc = 0;
  maxAcc = 1;
  distance = 0;
  currentDistance = 0;

  Body.setPosition(player1, {x:  localStorage.getItem('IsGuest') === "true" ? guestxPos : hostxPos, y: CANVAS_HEIGHT * 0.5})
  Body.setPosition(player2, {x:  localStorage.getItem('IsGuest') === "false" ? guestxPos : hostxPos, y: CANVAS_HEIGHT * 0.5})
}

export function GameStart(){
  player1 = Bodies.rectangle(
    localStorage.getItem('IsGuest') === "true" ? guestxPos : hostxPos, // x pos
    CANVAS_HEIGHT * 0.5,  // y pos
    30, //width
    30, //height,
    { isStatic: false,
      label: 'Player1',
      friction: 0,
      render: {
        fillStyle: 'transparent'
      },
      collisionFilter: {
        mask: P1category
      }
    }
  )

  player2 = Bodies.rectangle(
    localStorage.getItem('IsGuest') === "false" ? guestxPos : hostxPos, // x pos
    CANVAS_HEIGHT * 0.5,  // y pos
    30, //width
    30, //height,
    { isStatic: false,
      label: 'Player2',
      friction: 0,
      render: {
        fillStyle: 'transparent'
      },
      collisionFilter:{
        mask: P2category
      }
    }
  )

  ground1 = Bodies.rectangle(CANVAS_WIDTH * 0.3, CANVAS_HEIGHT * 0.8, CANVAS_WIDTH * 0.5 , CANVAS_HEIGHT / 32, { isStatic: true, label: 'Ground', render: {fillStyle: 'red'}, collisionFilter: {category: P1category | P2category}});
  ground2 = Bodies.rectangle(CANVAS_WIDTH, CANVAS_HEIGHT * 0.8, CANVAS_WIDTH / 2 , CANVAS_HEIGHT / 32, { isStatic: true, label: 'Ground', render: {fillStyle: 'green'}, collisionFilter: {category: P1category | P2category} });
  ground3 = Bodies.rectangle(CANVAS_WIDTH * 2, CANVAS_HEIGHT * 0.8, CANVAS_WIDTH * 0.5 , CANVAS_HEIGHT / 32,  { isStatic: true, label: 'Ground' , render: {fillStyle: 'blue'}, collisionFilter: {category: P1category | P2category}});

  Composite.add(engine.world, [player1, player2, ground1, ground2, ground3]);

  Render.run(render);

  var runner = Runner.create();

  let PlayerState = {}
  let PlayerState2 = {}
  const canvas = document.querySelectorAll("canvas")[1];
  canvas.style.width = window.innerWidth + 'px'
  canvas.style.height = window.innerHeight + 'px'
  const ctx = canvas.getContext("2d");

  animateOnline(PlayerState, PlayerState2, player1, player2, ctx)
  bacgrkoundparallax(ctx)

  Events.on(engine, "beforeUpdate", Update)

  let holdCounterP1 = 0;
  let isHoldingJumpP1 = false
  let groundPos1;
  let groundPos2;
  let groundPos3;
  let isGround1OffScreen = false;
  let isGround2OffScreen = false;
  let isGround3OffScreen = false;
  let rightKeyPress = false;
  let leftKeyPress = false;
  let noGravityP1 = true

  document.addEventListener("keydown", (e)=>{
    if(e.code === 'Space' || e.code === 'KeyZ' || e.code === 'ArrowUp'){
      if(isP1Grounded){
        PlayerJump1()
        SendAction('jump press')
      }
    }
  })

  document.addEventListener("keyup", (e)=>{
    if(e.code === 'Space' || e.code === 'KeyZ' || e.code === 'ArrowUp'){
      isHoldingJumpP1 = false
      SendAction('jump release')
    }
  })

  document.addEventListener("keydown", (e)=>{
    if(e.code === 'KeyD' || e.code === 'ArrowRight'){
      rightKeyPress = true;
      SendAction('right press')
    }
  })

  document.addEventListener("keydown", (e)=>{
    if(e.code === 'KeyQ' || e.code === 'ArrowLeft'){
      leftKeyPress = true;
      SendAction('left press')
    }
  })

  document.addEventListener("keyup", (e)=>{
    if(e.code === 'KeyD' || e.code === 'ArrowRight'){
      rightKeyPress = false;
      SendAction('right release')
    }
  })
  
  document.addEventListener("keyup", (e)=>{
    if(e.code === 'KeyQ' || e.code === 'ArrowLeft'){
      leftKeyPress = false;
      SendAction('left release')
    }
  })

  if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {//check if mobile
    AddingControlls()
  }



  function Update() {
    if (gameOver){
      if (P1RestartReady && P2RestartReady){
        P1RestartReady = false
        P2RestartReady = false
        RestartGame()
      }
      return
    }

    groundPos1 = ground1.position.x;
    groundPos2 = ground2.position.x;
    groundPos3 = ground3.position.x;

    if(isHoldingJumpP1){      
      holdCounterP1 += 1
      let gravity = engine.world.gravity;
      if (noGravityP1){
        Body.applyForce(player1, player1.position, {
          x: 0,
          y: -gravity.y * gravity.scale * player1.mass
        });
      }
      noGravityP1 = true
      P1airState = "Ascend"
      if(holdCounterP1 >= 150){
        isHoldingJumpP1 = false;
        holdCounterP1 = 0;
      }
    }else{
      noGravityP1 = false
      if (!isP1Grounded){
      P1airState = "Descend"
      }
    }

    if(isHoldingJumpP2){
      holdCounterP2 += 1
      let gravity = engine.world.gravity;
      if (noGravityP2){
        Body.applyForce(player2, player2.position, {
          x: 0,
          y: -gravity.y * gravity.scale * player2.mass
        });
      }
      noGravityP2 = true
      P2airState = "Ascend"
      if(holdCounterP2 >= 150){
        isHoldingJumpP2 = false;
        holdCounterP2 = 0;
      }
    }else{
      noGravityP2 = false
      if (!isP2Grounded){
      P2airState = "Descend"
      }
    }

    if(isP1Grounded || isP2Grounded){
      let ratio = speedVel / maxVel;
      acc = maxAcc * (1 - ratio)
      speedVel += acc;
      if(speedVel >= maxVel){
        speedVel = maxVel
      }
    }
    distance += speedVel;  

    groundPos1 -= (speedVel / 100)
    Body.setPosition(ground1, {x: groundPos1, y: ground1.position.y})
    groundPos2 -= (speedVel / 100)
    Body.setPosition(ground2, {x: groundPos2, y: ground2.position.y})
    groundPos3 -= (speedVel / 100)
    Body.setPosition(ground3, {x: groundPos3, y: ground3.position.y})
    
    CheckGround1()
    CheckGround2()
    CheckGround3()
    CheckPlayers()
    CheckInputP1()
    CheckInputP2()
    UpdateDistanceCounter()
    CheckGameOver()
  }//END UPDATE //

  function AddingControlls(){
    let parent = canvas.parentElement
    let jumpButton = document.createElement("div")
    jumpButton.addEventListener("ontouchstart", PlayerJump1)
    jumpButton.addEventListener("ontouchend", ()=>{
      isHoldingJumpP1 = false
    });

    jumpButton.className = "jumpBtn"
    parent.appendChild(jumpButton)

    let rightArrow = document.createElement("div")
    rightArrow.addEventListener("ontouchstart", ()=>{
      rightKeyPress = true
    })
    rightArrow.addEventListener("ontouchend", ()=>{
      rightKeyPress = false
    });

    rightArrow.className = "touchArrow rightArrow"
    parent.appendChild(rightArrow)

    let leftArrow = document.createElement("div")
    leftArrow.addEventListener("ontouchstart", ()=>{
      leftKeyPress = true
    })
    leftArrow.addEventListener("ontouchend", ()=>{
      leftKeyPress = false
    });

    leftArrow.className = "touchArrow leftArrow"
    parent.appendChild(leftArrow)
  }
  
  
  function UpdateDistanceCounter(){
    currentDistance = Math.floor(distance / 10000)
    ctx.font = "50px Source Code Pro";
    ctx.fillStyle = "red"
    ctx.fillText(currentDistance + 'm', CANVAS_WIDTH - 200, 100)
  }
  
  function CheckInputP1(){
    if(rightKeyPress){
      Body.applyForce(player1, player1.position, {x: 0.0002, y: 0})
    }
    if(leftKeyPress){
      Body.applyForce(player1, player1.position, {x: -0.0002, y: 0})
    }
  }

  function CheckInputP2(){
    if(rightKeyPressP2){
      Body.applyForce(player2, player2.position, {x: 0.0002, y: 0})
    }
    if(leftKeyPressP2){
      Body.applyForce(player2, player2.position, {x: -0.0002, y: 0})
    }
  }
  
  function CheckPlayers(){
    if(player1.position.y > CANVAS_HEIGHT){
      P1fallen = true
    }
    if(player2.position.y > CANVAS_HEIGHT){
      P2fallen = true
    }
  }

  function PlayerJump1(){
    isHoldingJumpP1 = true
    Body.applyForce(player1, player1.position, {x: 0, y: -0.02 })
    isP1Grounded = false
    holdCounterP1 = 0
  }
  
  function CheckGround1(){
    let {min, max} = ground1.bounds
    let groundW1 = max.x - min.x
    isGround1OffScreen = ((ground1.position.x + (groundW1 / 2) ) < 0)
    if(isGround1OffScreen){
      let params = GetRandomParam()
      RespawnGround1(params);
      sendDataChannel({type: 'platform', platform: 1, RndX: params.RndX, RndY: params.RndY, RndWith: params.RndWith})
    }
  }

  function CheckGround2(){
    let {min, max}  = ground2.bounds
    let groundW2 = max.x - min.x
    isGround2OffScreen = ((ground2.position.x + (groundW2 / 2) ) < 0)
    if(isGround2OffScreen){
      let params = GetRandomParam()
      RespawnGround2(params)
      sendDataChannel({type: 'platform', platform: 2, RndX: params.RndX, RndY: params.RndY, RndWith: params.RndWith})
    }
  }

  function CheckGround3(){
    let {min, max} = ground3.bounds
    let groundW3 = max.x - min.x
    isGround3OffScreen = ((ground3.position.x + (groundW3 / 2) ) < 0)
    if(isGround3OffScreen){
      let params = GetRandomParam()
      RespawnGround3(params)
      sendDataChannel({type: 'platform', platform: 3, RndX: params.RndX, RndY: params.RndY, RndWith: params.RndWith})
    }
  }
  
  function GetRandomParam(){
    let maxScale = 1.5
    let minScale = 0.5
    let RndWith = (Math.random() * (maxScale - minScale) + minScale)
    RndWith = Math.round(RndWith* 10)  / 10
    let RndY = (Math.floor(Math.random() * 5 + 1) / 10) + 0.4
    let ground1Width = GetGroundWidth(ground1);
    let ground3Width = GetGroundWidth(ground3);
    let minDistance = (ground1Width ) + (ground3Width );
    let RndX = CANVAS_WIDTH + minDistance;
    return {RndWith, RndX, RndY }
  }
  
  function GetGroundWidth(ground){
    let {min, max}  = ground.bounds
    return max.x - min.x
  }

  function CheckGameOver(){
    if(versusGamemode){
      if(P1fallen){
        gameOver = true;
        ShowGameOverScreen('Player 2')
      }
      if(P2fallen){
        gameOver = true;
        ShowGameOverScreen('Player 1')
      }
    }else{
      if(P1fallen && P2fallen){
        gameOver = true;
        ShowGameOverScreen('Both players')
      }
    }
  }

  function ShowGameOverScreen(playerName){
    if (!gameOver){
      return
    }
    let parent = canvas.parentElement
    let gameOverContainer = document.createElement("div")
    gameOverContainer.className = "gameOver"
    let textP = document.createElement("p")
    textP.innerHTML = "The run is finished. We have a Winner!"
    let highScoreSpan = document.createElement("span")
    highScoreSpan.className = "highscore"
    if(versusGamemode){
      highScoreSpan.innerHTML = playerName + " has won!"
    }else{
      highScoreSpan.innerHTML = playerName + " have fallen with a score of: " + currentDistance + "m"
    }

    let btnContainer = document.createElement("div")
    let backBtn=  document.createElement("button")
    backBtn.innerHTML = "Back"
    backBtn.onclick = () =>{
      window.location.pathname = "/menu"
    }
    let retryBtn = document.createElement("button")
    retryBtn.innerHTML = "Retry"
    
    retryBtn.onclick = () =>{
      P1RestartReady = true
      sendDataChannel({type:'restart'})
      textP.innerHTML = "The run is finished. Waiting for the player to get ready..."
    }
    
    btnContainer.appendChild(backBtn)
    btnContainer.appendChild(retryBtn)

    gameOverContainer.appendChild(textP)
    gameOverContainer.appendChild(highScoreSpan)
    gameOverContainer.appendChild(btnContainer)
    parent.appendChild(gameOverContainer)
  }

  Events.on(engine, 'collisionStart', function(event) {
    var pairs = event.pairs[0];
    if(pairs.bodyA.label === 'Player1' && pairs.bodyB.label === 'Ground'){
      isP1Grounded = true;
      P1airState = "ground"
    }
    if(pairs.bodyA.label === 'Player2' && pairs.bodyB.label === 'Ground'){
      isP2Grounded = true;
      P2airState = "ground"
    }
  });
  
  Events.on(engine, 'collisionEnd', function(event) {
    var pairs = event.pairs[0];
    if(pairs.bodyA.label === 'Player1' && pairs.bodyB.label === 'Ground'){
      isP1Grounded = false;
    }
    if(pairs.bodyA.label === 'Player2' && pairs.bodyB.label === 'Ground'){
      isP2Grounded = false;
    }
  });
}

export function RespawnGround1(params){//RED
  Body.scale(ground1, 1 / prevRndWidthGround1 , 1)
  prevRndWidthGround1 = params.RndWith;
  Body.scale(ground1, params.RndWith, 1)

  if (params.RndX > ground3.position.x + ((params.RndX - CANVAS_WIDTH) / 2)){
    Body.setPosition(ground1, {x: params.RndX, y: CANVAS_HEIGHT * params.RndY})
  }
}

export function RespawnGround2(params){//RED
  Body.scale(ground2, 1 / prevRndWidthGround2 , 1)
  prevRndWidthGround2 = params.RndWith;
  Body.scale(ground2, params.RndWith, 1)

  if (params.RndX > ground1.position.x + ((params.RndX - CANVAS_WIDTH) / 2)){
    Body.setPosition(ground2, {x: params.RndX, y: CANVAS_HEIGHT * params.RndY})
  }
}

export function RespawnGround3(params){//BLUE
  Body.scale(ground3, 1 / prevRndWidthGround3 , 1)
  prevRndWidthGround3 = params.RndWith;
  Body.scale(ground3, params.RndWith, 1)
  if (params.RndX > ground2.position.x + ((params.RndX - CANVAS_WIDTH) / 2)){
  Body.setPosition(ground3, {x: params.RndX, y: CANVAS_HEIGHT * params.RndY})
  }
}


export function setP2RestartReady(){
  P2RestartReady = true
  document.querySelector('.gameOver p').innerHTML = "The run is finished. The other player is ready for another run!"
}

export function EngineUpdate(){
  Matter.Engine.update(engine);
}

export function PlayerJump2(bool){
  isHoldingJumpP2 = bool
  if (isHoldingJumpP2){
    Body.applyForce(player2, player2.position, {x: 0, y: -0.02})
    isP2Grounded = false
    holdCounterP2 = 0
  }
}

export function Player2RightInput(bool){
  rightKeyPressP2 = bool
}

export function Player2LeftInput(bool){
  leftKeyPressP2 = bool
}

export { P1airState, P2airState, isP1Grounded, isP2Grounded, gameSpeed, ground1, ground2, ground3,
   isHoldingJumpP2, leftKeyPressP2, rightKeyPressP2}

export default MultiplayerGame